/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon16Solid = forwardRef('UiMenuDots9Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 4.498A1.499 1.499 0 1 0 13 1.5a1.499 1.499 0 0 0 0 2.998Z" }),
        React.createElement("path", { d: "M14.499 8A1.499 1.499 0 1 1 11.5 8a1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M3 14.498A1.499 1.499 0 1 0 3 11.5a1.499 1.499 0 0 0 0 2.998Z" }),
        React.createElement("path", { d: "M9.499 12.999a1.499 1.499 0 1 1-2.998 0 1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M14.499 12.999a1.499 1.499 0 1 1-2.998 0 1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M8 9.499A1.499 1.499 0 1 0 8 6.5a1.499 1.499 0 0 0 0 2.998Z" }),
        React.createElement("path", { d: "M4.499 8A1.499 1.499 0 1 1 1.5 8a1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M9.499 2.999a1.499 1.499 0 1 1-2.998 0 1.499 1.499 0 0 1 2.998 0Z" }),
        React.createElement("path", { d: "M3 4.498A1.499 1.499 0 1 0 3 1.5a1.499 1.499 0 0 0 0 2.998Z" })));
});
